var QueryStringFactory =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _QueryStringFactory = __webpack_require__(1);

var _QueryStringFactory2 = _interopRequireDefault(_QueryStringFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(window.onpopstate = function () {
    window.queryString = _QueryStringFactory2.default.make(window.location.href);
})();

module.exports = _QueryStringFactory2.default;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _QueryString = __webpack_require__(2);

var _QueryString2 = _interopRequireDefault(_QueryString);

var _UrlParams = __webpack_require__(3);

var _UrlParams2 = _interopRequireDefault(_UrlParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QueryStringFactory = function () {
    function QueryStringFactory() {
        _classCallCheck(this, QueryStringFactory);
    }

    _createClass(QueryStringFactory, null, [{
        key: 'make',
        value: function make(url) {
            return new _QueryString2.default(new _UrlParams2.default(url));
        }
    }]);

    return QueryStringFactory;
}();

exports.default = QueryStringFactory;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QueryString = function () {
    function QueryString(urlParams) {
        _classCallCheck(this, QueryString);

        this.urlParams = urlParams.getParams();
        this.baseUrl = urlParams.getBaseUrl();
    }

    _createClass(QueryString, [{
        key: 'get',
        value: function get(key) {
            return this.urlParams[key];
        }
    }, {
        key: 'add',
        value: function add(newKey, newValue) {
            var queryString = [];

            for (var i in this.urlParams) {
                if (i != newKey && i != 'page') {
                    queryString.push(i + '=' + this.urlParams[i]);
                }
            }

            queryString.push(newKey + '=' + newValue);
            return this.baseUrl + '?' + queryString.join('&');
        }
    }, {
        key: 'remove',
        value: function remove(key) {
            var queryString = [];

            for (var i in this.urlParams) {
                if (i != key) queryString.push(i + '=' + this.urlParams[i]);
            }

            return this.baseUrl + '?' + queryString.join('&');
        }
    }]);

    return QueryString;
}();

exports.default = QueryString;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UrlParams = function () {
    function UrlParams(url) {
        _classCallCheck(this, UrlParams);

        // parse query string and store parameters in an array
        var urlParams = {};
        var match;
        var pl = /\+/g; // Regex for replacing addition symbol with a space
        var search = /([^&=]+)=?([^&]*)/g;
        var decode = function decode(s) {
            return decodeURIComponent(s.replace(pl, " "));
        };

        var qIndex = url.indexOf('?');

        this.baseUrl = qIndex == -1 ? url : url.substr(0, qIndex);
        var query = qIndex == -1 ? '' : url.substr(qIndex).substr(1);
        while (match = search.exec(query)) {
            urlParams[decode(match[1])] = decode(match[2]);
        }

        this.urlParams = urlParams;
    }

    _createClass(UrlParams, [{
        key: 'getParams',
        value: function getParams() {
            return this.urlParams;
        }
    }, {
        key: 'getBaseUrl',
        value: function getBaseUrl() {
            return this.baseUrl;
        }
    }]);

    return UrlParams;
}();

exports.default = UrlParams;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// queryString.min.js